export default `
	teasersExperience {
		...on TeasersExperienceItem {
			imageLarge {
				filename
				height
				id
				size
				url(transform:coverImage)
				width
			}
			imageSmall1 {
				filename
				height
				id
				size
				url(transform:coverImage)
				width
			}
			imageSmall2 {
				filename
				height
				id
				size
				url(transform:coverImage)
				width
			}
		}
	}
`;
